import { vsName as componentName } from "./component";
import {
  MachineDetailTabsProvider,
  vsProviderName as machineDetailTabsProviderName,
} from "../../../../components/machineDetailTabs";
import { Machine } from "../../../../models/machine";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../../records/server/serverUtility";

export function machineDetailPartsComponentConfig(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider.addTabConfig({
    displayName: "Parts",
    id: "parts",
    uiSrefFragment: "parts",
    requiredPermission: "partView",
    stateDefinition: {
      url: "/parts",
      component: componentName,
      resolve: {
        machine: ["machine", (machine: Machine) => machine],
        machineParts: [
          "machine",
          serverUtilityName,
          (machine: Machine, serverUtility: ServerUtility) => {
            const machineId = machine.Id;
            return serverUtility.sendApiRequest({
              method: "GET",
              url: `/api/machines/${machineId}/parts`,
            });
          },
        ],
      },
    },
  });
}
machineDetailPartsComponentConfig.$inject = [machineDetailTabsProviderName];
